export default "__VITE_ASSET__DjvWh$K5__";